import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
  LABELS_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import labels from './labels/labels.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import typebot from './typebot/typebot.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS, LABELS_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'agent_list', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...labels.routes,
    ...reports.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...conversationWorkflow.routes,
    ...typebot.routes,
  ],
};
